import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { ICategoria } from "../../../../interfaces/ICategoria";
import { useState } from "react";

interface ModalSelecionarCategoriaAcoesProps {
    open: boolean;
    onClose: () => void;
    categorias: ICategoria[];
    onAcaoSelecionada: (categoriaUuid: string) => void;
}

export const ModalSelecionarCategoriaAcoes = ({
    open,
    onClose,
    categorias,
    onAcaoSelecionada
}: ModalSelecionarCategoriaAcoesProps) => {
    const [categoriaSelecionada, setCategoriaSelecionada] = useState<string>('');

    const handleConfirmar = () => {
        if (categoriaSelecionada) {
            onAcaoSelecionada(categoriaSelecionada);
            handleFechar();
        }
    };

    const handleFechar = () => {
        setCategoriaSelecionada('');
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleFechar} maxWidth="sm" fullWidth>
            <DialogTitle>Selecionar Categoria</DialogTitle>
            <DialogContent>
                <FormControl fullWidth margin="normal">
                    <InputLabel>Categoria</InputLabel>
                    <Select
                        value={categoriaSelecionada}
                        onChange={(e) => setCategoriaSelecionada(e.target.value)}
                        label="Categoria"
                    >
                        <MenuItem value="">Selecione uma categoria</MenuItem>
                        {categorias.map((categoria) => (
                            <MenuItem key={categoria.uuid} value={categoria.uuid}>
                                {categoria.descricao}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleFechar}>Cancelar</Button>
                <Button
                    onClick={handleConfirmar}
                    variant="contained"
                    disabled={!categoriaSelecionada}
                >
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

